import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const BreadcrumbsContainer = styled.div`
  font-family: system-ui;
  font-weight: 500;
  width: max-content;
  flex-wrap: wrap;
`

const BreadcrumbLink = styled.a`
  outline: none;
  display: block;
  float: left;
  font-size: 0.8rem;
  line-height: 25px;
  color: #b5b5b5;
  padding: 0 4px;
  border-radius: 5px;
  font-family: 'Plus Jakarta Sans';
  font-weight: 600;

  &:hover,
  &.active {
    color: #3249d7;
  }
  &.active {
    cursor: auto;
    color: #3249d7 !important;
  }

  &.navigate-cursor {
    cursor: pointer;
  }
`

const Breadcrumbs = (props) => {
  const { breadCrumbData, setIsNavigateEnabled = () => {},setStudentListId,setIsAllSelect,setStudentId } = props; // Default to no-op function
  const breadcrumbArr = breadCrumbData?.filter(
    (item) =>
      item.title !== 'null' &&
      item.title !== 'undefined' &&
      !(item.active && item.name !== 'Placement')
  );
  const navigate = useNavigate();
  const handleNavigation = (navigatePath) => {
    setStudentListId([]);
    setIsAllSelect(false);
    setStudentId('');
    if (navigatePath) {
      setIsNavigateEnabled(true);
      navigate(navigatePath);
    } else {
      setIsNavigateEnabled(false);
    }
  };

  return (
    <BreadcrumbsContainer>
      {breadcrumbArr.map((item, index) => {
        const isActive = index === breadcrumbArr.length - 1;
        return (
          <BreadcrumbLink
            key={index + 'breadcrumbLink'}
            href={item.navigate ? null : item.href}
            className={
              isActive ? 'active' : item.navigate ? 'navigate-cursor' : ''
            }
            onClick={
              item.navigate
                ? () => handleNavigation(item.navigate)
                : () => setIsNavigateEnabled(false)
            }
          >
            {item.title === 'DIPLOMA'
              ? 'Diploma'
              : item.title.replace(/%20/g, ' ')}
            <span style={{ padding: '0px 0px 0px 8px' }}>
              {index !== breadCrumbData.length - 1 && '/'}
            </span>
          </BreadcrumbLink>
        );
      })}
    </BreadcrumbsContainer>
  );
};

export default Breadcrumbs;
